import { ImageName } from "@mcleod/images";
import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { Button } from "../../../../button/Button";

export class AddButton extends AbstractTableHeadingButton {
    private _caption: string;
    
    override create() {
        super.create();
        this.button.setProps({
            id: "buttonAdd",
            caption: "Add",
            imageName: ImageName.add,
            color: "primary",
            hotkey: "Alt-A",
            onClick: () => this.table.crudManager.showAdd(),
            tooltip: "Add a new record",
        });
    }

    // We shouldn't need this, but AppTableHeadingPanel got a compile error without it
    override get(): Button {
        return this.button;
    }

    public get caption(): string {
        return this._caption == null ? "Add" + this.getLayoutTitleSuffix() : this._caption;
    }

    public set caption(value: string) {
        this._caption = value;
        this.syncCaption();
    }

    public syncCaption() {
        if (this.button != null)
            this.button.caption = this.caption;
    }

    private getLayoutTitleSuffix(): string {
        // let parent = this.table;
        // while (parent != null && !(parent instanceof Layout))
        //     parent = parent.parent;
        // const title = (parent as Layout)?.titleSingular?.toString();
        const title = this.button?.getParentLayout()?.titleSingular?.toString();
        return title == null ? "" : " " + title;
    }
}
